import { Injectable } from '@angular/core';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';
import { VantageShellService } from 'src/app/services/vantage-shell/vantage-shell.service';
import { DeviceService } from 'src/app/services/device/device.service';

@Injectable({ providedIn: 'root' })
export class WifiSecurityPresenterService {
	private wifiSecurity;
	private visibilityCache: boolean | null = null;
	constructor(
		private vantageShellService: VantageShellService,
		private featureToggleService: FeatureToggleService,
		private deviceService: DeviceService
	) {
		let securityAdvisor = this.vantageShellService.getSecurityAdvisor();
		if (securityAdvisor) {
			this.wifiSecurity = securityAdvisor.wifiSecurity;
		}
	}
	public isVisible(): Promise<boolean> {
		return new Promise((resolve) => {
			if (this.visibilityCache !== null) {
				resolve(this.visibilityCache);
			} else if (
				this.wifiSecurity &&
				this.featureToggleService.isPageAvailable('wifiSecurity')
			) {
				Promise.all([
					this.wifiSecurity.getWifiSecurityStateOnce(),
					this.deviceService.IsArm(),
				]).then((results) => {
					if (results && results.length) {
						if (results[0] !== undefined && results[1] !== true) {
							this.visibilityCache = this.wifiSecurity.isSupported;
						} else {
							this.visibilityCache = false;
						}

						resolve(this.visibilityCache);
					}
				});
			} else {
				this.visibilityCache = false;
				resolve(false);
			}
		});
	}
}
